import { isPerformanceInsightsTabDisabled } from '@amzn/passportweb-CarrierPerformanceInsactUIAssets/dist/utils/releaseControl';
import { CASE_MANAGEMENT_PATH, RUBIKS_PATH } from './navigationalRoutes';

export const sideNavItemsExternal = [
  {
    link: '/landing-page',
    label: 'home_page.sidebar_label',
    isAuthorized: true, // Home Tab on sidebar doesnt require any permissions
  },
  {
    link: '/dashboard/forecast',
    label: 'sidebar_labels.forecast',
    pamPermKey: 'TRANSPORTATION_FORECAST',
  },
  {
    link: '/dashboard/capacity-management',
    label: 'sidebar_labels.adhoc_capacity',
    isDisabled: false,
    pamPermKey: 'TRANSPORTATION_ADHOC_CAPACITY_REQUEST',
  },
  {
    link: RUBIKS_PATH,
    label: 'sidebar_labels.rubiks',
    pamPermKey: 'RUBIKS'
  },
  {
    link: '#',
    label: 'sidebar_labels.performance',
    children: true,
    isDisabled: false,
    childNodes: [
      {
        link: '/dashboard/performance-management',
        label: 'sidebar_labels.npc',
        children: false,
        isDisabled: false,
        pamPermKey: 'SP_NON_PERFORMANCE_COMPENSATION',
      },
      {
        link: '/dashboard/performance-insights',
        label: 'sidebar_labels.performance_insights',
        children: false,
        isDisabled: isPerformanceInsightsTabDisabled(),
        pamPermKey: 'SP_PERFORMANCE_MANAGEMENT',
      },
      {
        link: '/dashboard/performance-dashboard',
        label: 'sidebar_labels.performance_dashboard',
        children: false,
        isDisabled: false,
        pamPermKey: 'SP_PERFORMANCE_MANAGEMENT',
      },
    ],
  },
];

export const sideNavSupportItemsExternal = [
  {
    link: CASE_MANAGEMENT_PATH,
    label: 'sidebar_labels.case_management',
    isDisabled: false,
  },
];
export default {
  sideNavItemsExternal,
  sideNavSupportItemsExternal,
};
